/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import {
  CContainer, CRow, CCol, CCard, CCardBody, CCardHeader,
  CBreadcrumb, CBreadcrumbItem
} from '@coreui/react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { updateWeaveColorRequestAction } from '../../store/weavecolor/weaveColorActions';
import WeaveColorInputs from '../../components/WeaveColorInputs/WeaveColorInputs';
import {
  getWeaves, getThreads, getYarns, getColors
} from '../../services/endpoints';

const UpdateWeaveColor = ({ updateWeaveColorRequest, isLoading, updateWeaveColorData, weaveColorList }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const fromList = weaveColorList.find(x => x.WeaveColorId?.toString() === id);
  const _weaveColor = location.state?.weaveColor || fromList || null;

  const [dropdowns, setDropdowns] = useState({
    weaveList: [],
    threadList: [],
    yarnList: [],
    colorList: [],
  });

  useEffect(() => {
    const fetchDropdowns = async () => {
      const sessionUserId = localStorage.getItem('sessionUserId');
      const payload = { SessionUserId: sessionUserId };
      const [weaveRes, threadRes, yarnRes, colorRes] = await Promise.all([
        getWeaves(payload),
        getThreads(payload),
        getYarns(payload),
        getColors(payload),
      ]);
      setDropdowns({
        weaveList: weaveRes.data?.WeaveList || [],
        threadList: threadRes.data?.ThreadList || [],
        yarnList: yarnRes.data?.YarnList || [],
        colorList: colorRes.data?.ColorList || [],
      });
    };

    fetchDropdowns();
  }, []);

  const handleSubmit = (data) => {
    updateWeaveColorRequest({ data, navigate });
  };

  const handleCancel = () => {
    navigate('/weavecolor');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/weavecolor" onClick={(e) => { e.preventDefault(); handleCancel(); }}>
          WeaveColor
        </CBreadcrumbItem>
        <CBreadcrumbItem active>Update</CBreadcrumbItem>
      </CBreadcrumb>

      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader><h4>Update Weave Color</h4></CCardHeader>
            <CCardBody>
              {_weaveColor ? (
                <WeaveColorInputs
                  onSubmit={handleSubmit}
                  onCancel={handleCancel}
                  isLoading={isLoading}
                  submitResponse={updateWeaveColorData}
                  initialData={_weaveColor}
                  isEdit={true}
                  {...dropdowns}
                />
              ) : (
                <div className="text-center py-4 text-muted">Weave color not found</div>
              )}
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.loadingReducer.isLoading,
  updateWeaveColorData: state.weaveColorReducer.updateWeaveColorData,
  weaveColorList: state.weaveColorReducer.weaveColorList,
});

const mapDispatchToProps = {
  updateWeaveColorRequest: updateWeaveColorRequestAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateWeaveColor);
